import { makeStyles } from "@material-ui/core/styles";
import { theme } from "../../../../../../zApps/Layout";
import { DarkButton } from "../../../../../Button/DarkButton";
import { fetchSetMuteStatus } from "../../../../../Message/MessagePanel/components/fetchSetMuteStatus";
import { Post } from "../../types";

export function MutedPost({
    userId,
    post,
    tmpMutedUserIds,
    setTmpMutedUserIds,
}: {
    userId: number;
    post: Post;
    tmpMutedUserIds: number[];
    setTmpMutedUserIds: (ids: number[]) => void;
}) {
    const c = useStyles();
    return (
        <div className={c.container}>
            <div>Muted user's post</div>
            <DarkButton
                onClick={() => {
                    setTmpMutedUserIds(
                        tmpMutedUserIds.filter(id => id !== post.userId)
                    );
                    fetchSetMuteStatus(userId, post.userId, false);
                }}
                className={c.undo}
                size="small"
            >
                Undo
            </DarkButton>
        </div>
    );
}
const useStyles = makeStyles({
    container: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: theme.palette.grey[300],
        margin: 5,
        padding: 10,
    },
    undo: {
        maxHeight: 30,
        minHeight: 30,
        fontSize: "15px !important",
        lineHeight: 1,
    },
});
